module.exports = __webpack_public_path__ + "img/home_menu_15_selected.7f0eef5c.png";